import React from 'react';
import { Ticket } from '../../common-types/Ticket.type';
import { GameResultDto, Operation, ShopperExperienceDto, SitePublicData } from '@luckycart/xpn-types';

export type InformationType = {
  ticket?: Ticket,
  site?: SitePublicData,
  operation?: Pick<Operation, '_id' | 'legal'>,
  gameCount?: number | undefined,
  gamePlayed?: GameResultDto,
  experience?: ShopperExperienceDto,
}
type InformationContextType = {
  information: InformationType;
  setInformation: (info: InformationType) => void;
};

export const InformationContext = React.createContext<InformationContextType>({
  information: {},
  setInformation: () => undefined as void,
});
